module.exports = __webpack_public_path__ + "img/professional-icon-01.fc7a0495.png";